// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__BxQ9C","row":"ProcedureTreatmentSummary_row__2cUpc"};